/**
 * resolveFormDeriveLockedFieldIds
 *
 * The fieldIds every field-target entry writes. One source feeds both
 * `FormType.protected.derivedFieldIds` and the FormUI input lock, so the two can
 * never disagree about which fields the user may not edit.
 *
 * Lockedness is config-derived, exactly as a formula-target column is locked in
 * the grid: no per-value marker exists and none is needed. `FormDeriveEntry` has
 * no top-level discriminant, so field targets are recognized by narrowing the
 * target itself with `'fieldId' in entry.target` — never by a cast.
 */

import type { FormDeriveEntry } from '../System.FormDerive.types';
import type { FieldId } from '../System.types';

function resolveFormDeriveLockedFieldIds(entries: FormDeriveEntry[]): Set<FieldId> {
  return new Set(
    entries.flatMap((entry) => ('fieldId' in entry.target ? [entry.target.fieldId] : [])),
  );
}

export { resolveFormDeriveLockedFieldIds };
